export default __webpack_public_path__ + "static/media/commande.7fd37f10.svg";